import { createFileRoute } from '@tanstack/react-router';
import { AdminQuotesPage } from '@/features/admin/admin-quotes-page';

export const Route = createFileRoute('/admin/quotes/')({
  component: AdminQuotesIndexRoute,
});

function AdminQuotesIndexRoute() {
  return <AdminQuotesPage />;
}
